import store from '../store'

const config = {
    apiUrl: location.hostname !== 'localhost' ? `${location.origin}/api.php` : 'https://kreator.editello.com/api.php'
}

export default {
    getAll,
    getOneByHash,
    setProject,
    setProjectStatus,
    deleteProject
};

function getAll() {

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`
        }
    };

    return fetch(`${config.apiUrl}?action=projects`, requestOptions).then(handleResponse);
}


function getOneByHash(id) {

    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`
        }
    };

    return fetch(`${config.apiUrl}?action=project&hash=${id}`, requestOptions).then(handleResponse);
}

function setProject(data) {

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };

    return fetch(`${config.apiUrl}?action=setProject`, requestOptions).then(handleResponse);
}

function setProjectStatus(data) {

    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.getters['user/token']}`
        },
        body: JSON.stringify(data)
    };

    return fetch(`${config.apiUrl}?action=setProjectStatus`, requestOptions).then(handleResponse);
}

function deleteProject(projectId) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${store.getters['user/token']}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: projectId
        })
    };

    return fetch(`${config.apiUrl}?action=deleteProject`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}